// extracted by mini-css-extract-plugin
module.exports = {"secondaryText":"RemoveFolderModal-module__secondaryText--2QrRR","icon":"RemoveFolderModal-module__icon--1WMBS","directoryName":"RemoveFolderModal-module__directoryName--2rMgb"};